<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :style="{
      width: '0',
      height: '0',
      position: 'absolute',
      visibility: 'hidden',
    }"
    v-html="SvgSpriteSheet"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
import SvgSpriteSheet from '../../svg/sprites/sprite.svg?raw'

export default {
  name: 'SvgSprite',

  data() {
    return {
      SvgSpriteSheet,
    }
  },
}
</script>
